module Sm.Program

open BrowserNative
open Browser.Dom
open Fable.Core.JsInterop
open Fable.React

open Sm.UI
open Sm.UI.Main
open Sm.UI.App

open Sm.UI.Components.AppView

importSideEffects "./style/index.scss"

let host =
#if DEBUG
    "http://127.0.0.1:8090"
#else
    "https://app.somanyminutes.com/"
#endif

let client = Pocketbase.pocketbase.Create(host)
let args = Capabilities.queryParams ()
let app = App.create client args

Mousetrap.document |> registerKeyHandlers (fun cmd ->
    match app.Computed.Screen with
    | Main model -> model.Post(HandleCommand cmd)
    | _ -> ()
)

if Capabilities.hasTouchscreen then
    document.body.classList.add("is-touchscreen")

if Capabilities.isIOS then
    document.body.classList.add("is-ios")

let root = ReactDomClient.createRoot(document.getElementById("root"))
root.render(AppView {| App = app |})
